// extracted by mini-css-extract-plugin
export default {"container":"Unauthorized_container__lSaq7","title":"Unauthorized_title__KLg0G","text":"Unauthorized_text__B7r4j"};